var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { pca } from "./msal";
import { loginRequest } from "./auth-config";
import { API_BASE_URL } from "../config/app-config";
import { InteractionRequiredAuthError } from "@azure/msal-browser";
let appToken = null;
let expiryMs = 0;
let inflight = null;
/** Returns the current, non-expired app token, or null if a (re)exchange is needed. */
export function getAppToken() {
    if (appToken && Date.now() < expiryMs)
        return appToken;
    return null;
}
export function clearAppToken() {
    appToken = null;
    expiryMs = 0;
}
/** Acquire an Azure access token via MSAL (redirects to login when there's no session). */
function acquireAzureToken() {
    return __awaiter(this, void 0, void 0, function* () {
        var _a, _b;
        const account = (_a = pca.getAllAccounts()) === null || _a === void 0 ? void 0 : _a[0];
        if (!account) {
            yield pca.acquireTokenRedirect(loginRequest);
            return new Promise(() => { }); // block until the redirect navigates away
        }
        try {
            const result = yield pca.acquireTokenSilent(Object.assign(Object.assign({}, loginRequest), { account }));
            return (_b = result === null || result === void 0 ? void 0 : result.accessToken) !== null && _b !== void 0 ? _b : null;
        }
        catch (err) {
            if (err instanceof InteractionRequiredAuthError) {
                yield pca.acquireTokenRedirect(loginRequest);
                return new Promise(() => { });
            }
            return null;
        }
    });
}
function doExchange() {
    return __awaiter(this, void 0, void 0, function* () {
        const azureToken = yield acquireAzureToken();
        if (!azureToken)
            return { status: "failed" };
        try {
            const res = yield fetch(`${API_BASE_URL}auth/token`, {
                method: "POST",
                headers: { Authorization: `Bearer ${azureToken}` },
            });
            // 403 = authenticated tenant user who is not a provisioned app user.
            if (res.status === 403) {
                clearAppToken();
                return { status: "forbidden" };
            }
            if (!res.ok) {
                clearAppToken();
                return { status: "failed" };
            }
            const data = yield res.json();
            appToken = data.accessToken;
            const expiresInSec = Number(data.expiresIn) || 1800;
            // Refresh slightly early to avoid edge-of-expiry 401s.
            expiryMs = Date.now() + Math.max(0, expiresInSec - 30) * 1000;
            return { status: "ok", token: appToken };
        }
        catch (_a) {
            clearAppToken();
            return { status: "failed" };
        }
    });
}
/**
 * Exchange the Azure token for an app JWT. Single-flight: concurrent callers (e.g. all the
 * queries that fire on first load) share one in-flight exchange instead of stampeding.
 */
export function exchangeAppToken() {
    if (inflight)
        return inflight;
    inflight = doExchange().finally(() => {
        inflight = null;
    });
    return inflight;
}
